// extracted by mini-css-extract-plugin
module.exports = {"style-tabs":"index_style-tabs__2mnxG","labelHeader":"index_labelHeader__20Wx_","total":"index_total__2JbMR"};